import { LineItem } from '@commerce/types/cart'

function itemFoundInCart(entries: LineItem[], item: string): any {
  return {
    item: entries.find((entry) => entry.path === item),
  }
}
export default itemFoundInCart
